const DEVELOPMENT_EXTERNAL_CRUD_URLS = {
    salesOrders: 'https://localhost:3014',
};

const HAS_URL_SCHEME = /^[a-zA-Z][a-zA-Z\d+.-]*:/;

/**
 * Backend may return only a host (no scheme). Browsers then resolve that string as a
 * path on the current origin, so the iframe loads the parent app instead of the embed.
 */
export const ensureAbsoluteHttpUrl = (value) => {
    if (value == null || typeof value !== 'string') return null;

    const trimmed = value.trim();
    if (!trimmed) return null;

    if (trimmed.startsWith('//')) {
        return `https:${trimmed}`;
    }

    if (HAS_URL_SCHEME.test(trimmed)) {
        return trimmed;
    }

    return `https://${trimmed}`;
};

const isExternalCrudConfig = (value) => {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
};

export const normalizeExternalCrudConfig = (entityConfig) => {
    if (!isExternalCrudConfig(entityConfig)) return null;

    const normalizedId = Number.parseInt(entityConfig.id, 10);

    return {
        ...entityConfig,
        ...(Number.isNaN(normalizedId) ? {} : { id: normalizedId }),
    };
};

export const getExternalCrudConfig = (entityKey, userData = {}) => {
    if (!entityKey) return null;

    const entityConfig = userData?.entitiesWithExternalCRUD?.[entityKey];
    return normalizeExternalCrudConfig(entityConfig);
};

export const hasExternalCrud = (entityKey, userData = {}) => {
    return Boolean(getExternalCrudConfig(entityKey, userData));
};

export const getExternalCrudFallbackUrl = (entityKey) => {
    if (!entityKey) return null;

    if (process.env.NODE_ENV !== 'development') return null;

    return DEVELOPMENT_EXTERNAL_CRUD_URLS[entityKey] || null;
};
